import {
  SET_ERROR,
  SET_LOADING,
  SET_CATEGORIE,
  SET_CATEGORIE_TITLE
} from "@/store/constants/mutation-types";
import {
  MESSAGE_SUCCESS_CATEGORIE,
  MESSAGE_SUCCESS_CATEGORY_EDIT
} from "@/store/constants/messages";

const state = {
  category: {}
};

const getters = {
  /**
   * @description retourn les categories
   * @returns {category}
   */
  getCategory: () => state.category
};

const mutations = {
  [SET_CATEGORIE](state, category) {
    state.category = category;
  },
  [SET_CATEGORIE_TITLE](state, category) {
    state.category.hierarchyLabel = category.hierarchyLabel;
    state.category.hierarchyCode = category.hierarchyCode;
  }
};

const actions = {
  /**
   * @description Adds a Mirakl category
   * @param commit
   * @param dispatch
   * @param categoryMirakl
   * @returns {Promise<void>}
   */
  async addMiraklCategory({ commit, dispatch }, categoryMirakl) {
    try {
      commit(SET_LOADING, true, { root: true });
      await this._vm.$gwzApi
        .service("categories")
        .addCategorieMirakl(categoryMirakl);
      commit(SET_LOADING, false, { root: true });
      dispatch("setSuccessToast", MESSAGE_SUCCESS_CATEGORIE, { root: true });
    } catch (err) {
      commit(SET_LOADING, false, { root: true });
      commit(SET_ERROR, true, { root: true });
      dispatch("setErrorToast", err?.["hydra:description"], { root: true });
    }
  },

  /**
   * @description Edit a Mirakl category
   * @param commit
   * @param dispatch
   * @param categoryMirakl
   * @returns {Promise<void>}
   */
  async editMiraklCategory({ commit, dispatch }, { params, id }) {
    try {
      commit(SET_LOADING, true, { root: true });
      const { data } = await this._vm.$gwzApi
        .service("categories")
        .editCategorieMirakl(params, id);
      await commit(SET_CATEGORIE_TITLE, data);
      await commit(SET_LOADING, false, { root: true });
      dispatch("setSuccessToast", MESSAGE_SUCCESS_CATEGORY_EDIT, {
        root: true
      });
      return data;
    } catch (err) {
      commit(SET_LOADING, false, { root: true });
      commit(SET_ERROR, true, { root: true });
      dispatch("setErrorToast", err?.message, { root: true });
    }
  },

  /**
   * @description Get the info for a given Mirakl category
   * @param dispatch
   * @param id - Mirakl category id
   * @returns {Object} - Mirakl Category info or error object
   */
  async getMiraklCategoryInfo({ commit, dispatch }, id) {
    try {
      commit(SET_CATEGORIE, {});
      commit(SET_LOADING, true, { root: true });
      const { data } = await this._vm.$gwzApi
        .service("categories")
        .getMiraklCategory(id);
      const { data: mapping } = await this._vm.$gwzApi
        .service("categories")
        .getMappingCategories(id);
      data.mapping = mapping["hydra:member"];
      await commit(SET_CATEGORIE, data);
      await commit(SET_LOADING, false, { root: true });
    } catch (err) {
      commit(SET_LOADING, false, { root: true });
      commit(SET_ERROR, true, { root: true });
      dispatch("setErrorToast", err?.message, { root: true });
      return err;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
